import { TApiSetting } from "../api-client/settings-api"

export const DEFAULT_SETTINGS: Pick<TApiSetting, 'dateFormat' | 'approvalsPeriod' | 'defaultBillableRate'> = {
  dateFormat: 'YYYY-MM-DD',
  approvalsPeriod: 'monthly',
  defaultBillableRate: null,
}
